export enum DynamoPrefixes {
    org = 'ORG_',
    user = 'USER_',
    systemNotification = 'Notification_',
    supplier = 'S_',
    supplierRegistration = 'SupplierRegistration_',
    supplierRegistrationCode = 'SupplierRegistrationCode_',
    supplierData = 'Data_',
    supplierRequest = 'SR_',
    supplierVettingRequest = 'SVRequest_',
    supplierVettingRequestTemplate = 'SVRequestTemplate_',
    supplierActivity = 'SupplierActivity_',
    supplierMatch = 'SRMatch_',
    assessmentSubmission = 'Submission_',
    assessmentScore = 'Score',
    assessmentRecord = 'AssessRecord_',
    supplierReportLink = 'Report_',
    avatar = 'Avatar_',
    supplierSpotlight = 'SupplierSpotlight_',
    championApplication = 'ChampionApplication_',
    scaleupGrowthPlan = 'ScaleupGrowthPlan_',
    platformInvite = 'PlatformInvite_',
    discountCode = 'DiscountCode_',
    supplierSubscription = 'SupplierSubscription_',
    subscription = 'Subscription_',
    sourcingRequest = 'SR_',
    sourcingRequestMatch = 'SRMatch_',
    sourcingRequestMatchV2 = 'SRMatchV2_',
    sourcingAllySubscription = 'SourcingAllySubscription_',
    sourcingRequestFeedback = 'SRFeedback_',
    userEvent = 'UserEvent_',
    platformMetrics = 'PlatformMetrics_',
    enterpriseCustomer = 'EnterpriseCustomer_',
    enterpriseCustomerReport = 'EnterpriseCustomerReport_',
}